import styled from '@emotion/styled'

export const SurveyWrapper = styled.div((props) => ({}))

export const SurveyInner = styled.div((props) => ({
    background: props.theme.color.semantic.info[100],
    borderRadius: props.theme.spacing(2),
    padding: props.theme.spacing(6),
    color: props.theme.color.brand.secondary[900],
    boxSizing: 'border-box',

    [props.theme.breakpoints.down(props.theme.breakpoints.md)]: {
        padding: props.theme.spacing(3),
    },
}))

export const ButtonWrapperStyled = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',

    [theme.breakpoints.down(theme.breakpoints.md)]: {
        justifyContent: 'center',
    },
}))

export const SurveyTextArea = styled.textarea((props) => ({
    display: 'inline-block',
    width: '100%',
    border: 'none',
    borderRadius: props.theme.spacing(0.5),
    marginBottom: props.theme.spacing(2),
    minHeight: 150,
    fontFamily: props.theme.fonts.default,
    padding: `${props.theme.spacing(2)} ${props.theme.spacing(3)}`,
    color: props.theme.color.brand.secondary[900],
    boxSizing: 'border-box',

    '&:focus': {
        outline: 'none',
    },
}))

export const SurveyTitle = styled.h4((props) => ({
    display: 'block',
    marginBottom: props.theme.spacing(2),
    marginTop: 0,
    fontSize: props.theme.spacing(2.5),
}))

export const SurveyLabel = styled.label((props) => ({
    display: 'block',
    marginBottom: props.theme.spacing(2),
    marginTop: props.theme.spacing(3),
}))

export const SurveyRadio = styled.input((props) => ({
    marginBottom: props.theme.spacing(2),
}))

export const SurveyRadioWrapper = styled.div((props) => ({
    display: 'inline-block',
    marginBottom: props.theme.spacing(2),
    marginRight: props.theme.spacing(2),
}))
